import { Card, css, Heading, MAGNETIC_TOKENS, Tag } from '@appd/uik';
import { ReactNode } from 'react';
import type { SectionCardEntryPropsHealthGroup } from './SectionCardEntry';
import { SectionCardEntry } from './SectionCardEntry';
import { isArray } from 'lodash';

export interface SectionCardProps {
  title: string;
  onEntrySelect: (entry: SectionCardPropsEntry) => void;
  entries: SectionCardPropsEntry[];
  enableDrilldown: boolean;
}

export interface SectionCardPropsEntry {
  entityType: string;
  displayName: string;
  iconName: string;
  healthGroups: SectionCardEntryPropsHealthGroup[];
  children?: SectionCardPropsEntry[];
  enableDrilldown?: boolean;
}

function entryWithChildren(
  entry: SectionCardPropsEntry,
  indent: number,
  index: number,
  onEntrySelect?: (entry: SectionCardPropsEntry) => void,
  enableDrilldown?: boolean,
): ReactNode {
  const { entityType } = entry;
  if (!entityType) {
    debugger;
  }

  const parent = (
    <SectionCardEntry
      key={entityType}
      indentation={indent}
      onEntrySelect={onEntrySelect}
      className={index === 0 && { borderTop: `2px solid ${MAGNETIC_TOKENS.COLORS.CONTROL_BORDER_WEAK}` }}
      entry={entry}
      enableDrilldown={enableDrilldown}
    />
  );

  const children = (entry.children ?? []).map(childEntry =>
    entryWithChildren(childEntry, indent + 1, index + 1, onEntrySelect),
  );

  return [parent, children];
}

export function SectionCard({ entries, title, enableDrilldown = false, onEntrySelect }: SectionCardProps): JSX.Element {
  if (!isArray(entries)) return <></>;
  return (
    <div style={{ gridRow: `span ${entries.length + 2}`, padding: 0 }}>
      <div className={css({ display: 'flex', alignItems: 'center', gap: MAGNETIC_TOKENS.SPACING[2] })}>
        <Heading className={css({ marginBottom: 15 })} size="SUB_SECTION">
          {title}
        </Heading>
        {entries.length === 0 && <Tag className={css({ marginLeft: 'auto' })}>No data available</Tag>}
      </div>
      {entries.length > 0 && (
        <div>{entries.map((entry, index) => entryWithChildren(entry, 0, index, onEntrySelect))}</div>
      )}
    </div>
  );
}
